import React from "react";
import { LangLoader } from "@irati/utils/lang";
import { ACCOUNT, ONBOARDING } from "@irati-web/app/src/routeConfig";
import OnboardContainer from "./OnboardContainer";
import { TermsAndConditions } from "../components/UserOnboarding/index";
/** @author: Richard Scoones 16/8/2018
 *  @desc: Using LandLoader here as this page can potentionally be loaded in any context, not just onboarding flow.
 */
var TermsAndConditionsContainer = function () {
    return (React.createElement(LangLoader, { buckets: [ONBOARDING, ACCOUNT] },
        React.createElement(OnboardContainer, null,
            React.createElement(TermsAndConditions, null))));
};
export default TermsAndConditionsContainer;
